/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

function useCopycatSources() {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'copycatSources' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery([namespace], () => okapiKy.get('copycat/sources').json(), {
    enabled: true,
  });

  return {
    isLoading,
    isError,
    data,
    sourcesList: data.sources,
    refetch,
    rest,
  };
}

export default useCopycatSources;
